import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedFolder = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="folder" size="100%" color={stroke ?? color} />
);

export { LineRoundedFolder };
